module.exports = __webpack_public_path__ + "img/btn-sortear.d3aa1b3f.png";